
import { Options, Vue } from "vue-class-component";
// component imports
import EmailForm from "@/components/EmailForm.vue";
// firebase
import { getAuth, onAuthStateChanged } from "firebase/auth";
import {
  collection,
  getDocs,
} from "firebase/firestore";
import { db } from "@/firebase";
import 'remixicon/fonts/remixicon.css'

@Options({
  components: { EmailForm },
})
export default class ContactForms extends Vue {
  contacts: any = [];
  all_emails: any = [];
  all_email_ids: any = [];
  pageData: any = [];
  pageIDs: any = [];
  page: any = 1;
  pageStart: any = 0;
  pageEnd: any = 12;
  totalPages: any = 1;
  contacts_per_page: any = 12;
  beforeMount() {
    const auth = getAuth();
    onAuthStateChanged(auth, (user) => {
      if (user) {
        getDocs(collection(db, "form_emails", "oG7alUGMl8eBI5zEiSieDnoruEU2", "website_contact_form")).then(
          (QuerySnapshot) => {
            QuerySnapshot.forEach((doc) => {
              this.all_emails.push(doc.data());
              this.all_email_ids.push(doc.id);
            })
          }
        ).then(() => {
          this.pageData = this.all_emails.slice(this.pageStart, this.pageEnd);
          this.pageIDs = this.all_email_ids.slice(this.pageStart, this.pageEnd);
          this.totalPages = Math.ceil(this.all_emails.length / 12);
        })
      }
    })
  }
  prevPage() {
    if (this.page > 1) {
      this.page--;
      this.pageStart = this.pageStart - 12;
      this.pageEnd = this.pageEnd - 12;
      this.pageData = this.all_emails.slice(this.pageStart, this.pageEnd);
      this.pageIDs = this.all_email_ids.slice(this.pageStart, this.pageEnd);
    } else this.page = this.totalPages, this.pageStart = (this.totalPages - 1) * 12, this.pageEnd = 12 * this.totalPages, this.pageData = this.all_emails.slice(this.pageStart, this.pageEnd), this.pageIDs = this.all_email_ids.slice(this.pageStart, this.pageEnd);
  }
  nextPage() {
    if (this.page < this.totalPages) {
      this.page++;
      this.pageStart = this.pageStart + 12;
      this.pageEnd = this.pageEnd + 12;
      this.pageData = this.all_emails.slice(this.pageStart, this.pageEnd);
      this.pageIDs = this.all_email_ids.slice(this.pageStart, this.pageEnd);
    } else this.page = 1, this.pageStart = 0, this.pageEnd = 12, this.pageData = this.all_emails.slice(this.pageStart, this.pageEnd), this.pageIDs = this.all_email_ids.slice(this.pageStart, this.pageEnd);
  }
  contactPotentialClient(contact: any) {
    window.location.href = 'mailto:' + contact.email;
  }
}
